import React, { Fragment } from "react";

import "./LoginHomePage.css";
import { LOGIN, PROJECT_LOGIN, REGISTER, PROJECT_REGISTER } from "App/Routes";
import Link from "components/shared/Link/Link";
import LoginImageRow from "./LoginImageRow";
import LoginHomePage from "components/Login/LoginHomePage";

import { ENABLE_REGISTER_PAGES, ENABLE_OAUTH_LOGIN } from "config";
import urlServices from "services/urlServices";
import deviceServices from "services/deviceServices";
import localize from "lang/localize";

class NinjavilleLoginHomePage extends LoginHomePage {
  /*
    Custom: Register section similar to LoginPage.
  */
  renderRegisterSection() {
    if (ENABLE_REGISTER_PAGES) {
      return (
        <div className="topmargin-30">
          <p className="textcenter bottommargin-10">
            <strong>
              {localize("login_view_register_start", this.props.language) + " "}
            </strong>
          </p>
          <div className="flex justify-content-center">
            <Link
              className="button medium cta lowercase"
              to={
                this.props.projectId
                  ? PROJECT_REGISTER.format(this.props.projectId)
                  : REGISTER
              }
            >
              {localize("login_view_signup_text", this.props.language)}
            </Link>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  /*
    Custom: Guest Login section as button
    Guest Login applied platform-wide. API doesn't check for Project ID, so it's fine
  */

  renderGuestLoginSection() {
    return (
      <Fragment>
        <button
          className="button fullwidth cta large-padding-vertical"
          onClick={this.props.handleOpenGuestLoginDialog}
        >
          {localize("dialog_login_guest_title", this.props.language)}
        </button>
        {this.props.showGuestLoginDialog && this.renderGuestLoginDialog()}
      </Fragment>
    );
  }

  renderSSOLoginSection() {
    if (ENABLE_OAUTH_LOGIN) {
      return (
        <div className="pure-g">
          <div className="pure-u-1-1 topmargin-10 box-sizing-border-box-all">
            <p className="bottommargin textcenter">
              <strong>
                {localize("login_view_sign_in_start", this.props.language)}
              </strong>
            </p>
          </div>
          <div className="button-group-social-login">
            {this.renderFacebookLoginButton()}
            {this.renderGoogleLoginButton()}
            {this.renderMicrosoftLoginButton()}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  /* Custom: Very stylized Login Home page */
  render() {
    return (
      <div className="login-register-container container verticalpadding">
        <LoginImageRow />
        <div className="innerblock pure-g">
          <div className="pure-u-sm-2-24 pure-u-md-4-24" />
          <div className="pure-u-1 pure-u-sm-20-24 pure-u-md-16-24 login-panel">
            <div className="pure-g login-panel-buttons-container">
              <div className="pure-u-1-24" />
              <div
                className={
                  "pure-u-22-24" +
                  (ENABLE_REGISTER_PAGES ? " pure-u-sm-5-12" : "")
                }
              >
                <Link
                  className="button fullwidth cta large-padding-vertical"
                  to={
                    this.props.projectId
                      ? PROJECT_LOGIN.format(this.props.projectId)
                      : LOGIN
                  }
                >
                  {localize("button_login_email", this.props.language)}
                </Link>
              </div>
              <div className="pure-u-1-24 pure-u-sm-1-12" />
              <div className="pure-u-1-24 hide-from-sm" />
              <div className="pure-u-22-24 pure-u-sm-5-12">
                {this.renderGuestLoginSection()}
              </div>
              <div className="pure-u-1-24" />
            </div>
          </div>
          <div className="pure-u-sm-2-24 pure-u-md-4-24" />
        </div>
        {/* Add hidesso=true to query string in order to hide sso login, e.g. /login?hidesso=true */}
        {urlServices.getUrlParamValueByKey("hidesso") !== "true" &&
          !deviceServices.isWebView() &&
          this.renderSSOLoginSection()}
        {this.renderRegisterSection()}
      </div>
    );
  }
}

export default NinjavilleLoginHomePage;
